import axiosPost from "../axiosPost";

export const horarioRangoIns = async ({
    gateHorarioId,
    gateHorarioRangoDia,
    gateHorarioRangoDias,
    gateHorarioRangoEntrada,
    gateHorarioRangoSalida
}, credentials) => {
    const body = {
        service: "GateHorarioRangoIns",
        params: {
            gateHorarioId,
            ...(gateHorarioRangoDias === undefined ? { gateHorarioRangoDia } : { gateHorarioRangoDias }),
            gateHorarioRangoEntrada,
            gateHorarioRangoSalida
        },
    };

    return await axiosPost(body, credentials);
};
